import { Phone } from "lucide-react";
import { PHONE_DISPLAY } from "../../lib/site";

const Line = ({ label, value, testId }) => (
  <div className="min-w-0">
    <p className="text-[10px] font-medium uppercase tracking-[0.2em] text-gold-light/70">{label}</p>
    <p className="mt-0.5 truncate text-[15px] font-semibold text-white" data-testid={testId}>{value}</p>
  </div>
);

export const VoucherPreview = ({ item, recipient, sender, note, date, badge }) => (
  <div className="relative mx-auto w-full max-w-md" data-testid="voucher-preview">
    <div className="relative overflow-hidden rounded-3xl p-[1.5px]" style={{ background: "linear-gradient(135deg,#E6D3A3,#A8843F 45%,#E6D3A3 70%,#B08A47)" }}>
      <div className="bg-emerald-grad relative overflow-hidden rounded-[22px] px-6 pb-6 pt-7 sm:px-8">
        <div className="pointer-events-none absolute -right-14 -top-14 h-48 w-48 rounded-full border border-gold/20" />
        <div className="pointer-events-none absolute -right-6 -top-6 h-28 w-28 rounded-full border border-gold/15" />
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-[10px] font-medium tracking-[0.35em] text-gold-light/80">LUNESSA SPA &amp; MASAJ</p>
            <p className="mt-2 text-2xl font-bold tracking-[0.12em] text-gold-light sm:text-3xl">HEDİYE ÇEKİ</p>
          </div>
          <span className="flex shrink-0 rounded-2xl bg-cream p-1.5 ring-1 ring-gold/50">
            <img src="/images/lunessa-logo.webp" alt="lunessa-spa-masaj-logo" className="h-12 w-auto" width="48" height="48" />
          </span>
        </div>
        <div className="my-5 h-px bg-gradient-to-r from-gold/70 via-gold/30 to-transparent" />
        <p className="text-[10px] font-medium uppercase tracking-[0.2em] text-gold-light/70">Paket / Hizmet</p>
        <p className="mt-1 text-lg font-semibold leading-snug text-white" data-testid="voucher-item">{item || "Paket veya hizmet seçin"}</p>
        {badge && <span className="badge-gold mt-3">{badge}</span>}
        <div className="mt-5 grid grid-cols-2 gap-4">
          <Line label="Kime" value={recipient || "Alıcı adı"} testId="voucher-recipient" />
          <Line label="Kimden" value={sender || "Gönderen adı"} testId="voucher-sender" />
        </div>
        {note && <p className="mt-4 break-words text-sm italic leading-relaxed text-white/80" data-testid="voucher-note">“{note}”</p>}
      </div>
      <div className="relative bg-emerald-950">
        <span className="absolute -left-3 top-1/2 h-6 w-6 -translate-y-1/2 rounded-full bg-cream" />
        <span className="absolute -right-3 top-1/2 h-6 w-6 -translate-y-1/2 rounded-full bg-cream" />
        <div className="mx-5 border-t border-dashed border-gold/40" />
        <div className="flex items-center justify-between gap-3 rounded-b-[22px] px-6 py-4 text-xs text-white/75 sm:px-8">
          <span className="flex items-center gap-1.5"><Phone className="h-3.5 w-3.5 text-gold" /> {PHONE_DISPLAY}</span>
          <span data-testid="voucher-date">{date ? new Date(date).toLocaleDateString("tr-TR") : "Merkez / Sivas"}</span>
        </div>
      </div>
    </div>
  </div>
);
